import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import { useUserPermissions } from '@/hooks/useUserPermissions';
import { hasSystemToolsAccess, realmIdFromIssuer } from './systemToolsAccess';

/** Direct-URL guard for the platform control plane. API authorization remains
 * authoritative; this guard prevents rendering or prefetching a System Tool. */
const CorpSystemToolsRoute: React.FC = () => {
  const permissions = useUserPermissions();
  const { keycloak } = useKeycloak();
  if (permissions.isLoading) {
    return <div className="flex h-full items-center justify-center">Checking access…</div>;
  }
  const tokenRealm = realmIdFromIssuer((keycloak.tokenParsed as { iss?: unknown } | undefined)?.iss);
  if (!hasSystemToolsAccess(tokenRealm, permissions.roles)) {
    return <Navigate to="/chat" replace />;
  }
  return <Outlet />;
};

export default CorpSystemToolsRoute;
